import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { Dashboard } from './components/Dashboard';
import { AuthWrapper } from './components/AuthWrapper';
import { OAuthCallback } from './components/OAuthCallback';
import { AccountPage } from './pages/AccountPage';

const App: React.FC = () => {
  const [showAuthenticator, setShowAuthenticator] = useState<boolean>(false);

  const handleShowAuth = () => {
    setShowAuthenticator(true);
  };

  const handleHideAuth = () => {
    setShowAuthenticator(false);
  };

  return (
    <BrowserRouter>
      <AuthWrapper
        showAuthenticator={showAuthenticator}
        onHideAuthenticator={handleHideAuth}
      >
        {({ user, signOut }) => (
          <Routes>
            {/* OAuth callback route - always available */}
            <Route path="/callback" element={<OAuthCallback />} />

            {user ? (
              /* Authenticated routes */
              <>
                <Route path="/" element={<Dashboard user={user} onSignOut={signOut!} />} />
                <Route path="/account" element={<AccountPage user={user} />} />
                <Route path="*" element={<Dashboard user={user} onSignOut={signOut!} />} />
              </>
            ) : (
              /* Unauthenticated routes */
              <>
                <Route path="/" element={<LandingPage onSignIn={handleShowAuth} />} />
                <Route path="*" element={<LandingPage onSignIn={handleShowAuth} />} />
              </>
            )}
          </Routes>
        )}
      </AuthWrapper>
    </BrowserRouter>
  );
};

export default App;
